<template>
  <div class="row profile-user__row-owl">
    <div class="col">
      <div v-if="show">
        <carousel class="profile-owl-carousel" :nav="true" :loop="false" :dots="true" :margin="0" :responsive="responsive" :navText="[`<div class='arrow-left'></div>`,`<div class='arrow-right'></div>`]">

          <div v-if="imagesUnBlurred.length === 0 && imagesBlurred.length === 0" class="item">
            <div class="profile-card">
              <div
                class="profile-owl-carousel__img show profile-card__image profile-card__image-avatar"
                v-bind:style="{'background-image': 'url(' + profileAvatarUrl + '?p=small) '}"
              >
              </div>
            </div>
          </div>

          <div
            v-for="(media,key) in allMedia"
            class="item"
            :class="{'my-blurred': own && (media.price > 0)}"
          >
                        <span v-if="media.is_blurred" @click="buyMedia(media)">
                            <div class="profile-card">
                                <div
                                  class="profile-owl-carousel__img blurred profile-card__image"
                                  v-bind:style="{'background-image': 'url(' + media.url + '?p=small&type=blurred) '}"
                                >
                                    <div class="profile-card__middle">
                                        <p class="profile-card__coins-mobile" v-if="!own && user">
                                            {{ media.price }}
                                            <img src="../../../images/others/coin.svg" class="coin-icon">
                                        </p>
                                        <span>{{ trans.get('chat.img_click_to_view') }}</span>
                                    </div>
                                    <div class="righttop__corner">
                                        <p class="profile-card__coins" v-if="!own && user">{{ media.price }}
                                            <img src="../../../images/others/coin.svg" class="coin-icon">
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </span>
            <div
              v-else class="profile-card"
              :class="{'free-image-popup': user}"
              :data-mfp-src="media.url+'?p=big'"
              :data-mfp-id="media.id"
              title=""
              @click="openMagnificPopup(media.id)"
            >
              <div
                class="profile-owl-carousel__img show profile-card__image"
                v-bind:style="{'background-image': 'url(' + media.url + '?p=large) '}"
              >
                <div
                  v-if="!own && user"
                  class="righttop__corner js-photo-violation-modal"
                  @click="photoViolationAction(media.id)"
                >
                  <img src="../../../images/match-game/exclamation-triangle.svg" alt="exclamation triangle">
                </div>
              </div>
            </div>
          </div>

        </carousel>

      </div>
      <div v-else>
        <div class="profile-owl-carousel d-md-flex pl-1 pt-2">
          <div v-for="(index, media) in [1,2,3]" class="item" :class="{'d-none d-md-block': index > 1 }">
            <div class="profile-card ml-md-1 mr-md-3">
              <div class="profile-owl-carousel__img show profile-card__image">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PhotoReportModal></PhotoReportModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OwlCarousel from '../../modules/OwlCarousel';
import carousel from 'vue-owl-carousel';
import PhotoReportModal from './PhotoReportModal';

export default {
  name: 'GalleryComponent',
  components: { PhotoReportModal, OwlCarousel, carousel },
  props: {
    profileId: null,
    age: null,
    profileAvatarUrl: null,
  },
  data() {
    return {
      responsive: {
        0: { items: 1 },
        768: { items: 3 },
        1000: { items: 5 },
        1200: { items: 5 },
        1800: { items: 6 },
        2000: { items: 6 },
        3000: { items: 6 }
      },
      show: false,
      imagesUnBlurred: [],
      imagesBlurred: [],
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    own: function () {
      return this.user && (this.profileId === this.user.id);
    },
    allMedia: function () {
      return this.imagesUnBlurred.concat(this.imagesBlurred);
    },
  },
  methods: {
    fetchData: function () {
      let vm = this;
      axios.get(zRoute('ajax.profiles.media.index', this.profileId)).then((response) => {
        vm.show = false;
        let media = response.data.data;

        vm.imagesUnBlurred = media.filter((m) => !m.is_blurred);
        vm.imagesBlurred = media.filter((m) => m.is_blurred);

        this.$nextTick(() => {
          vm.show = true;
        });
      });
    },
    refreshImage: function (media) {
      let index = this.imagesBlurred.findIndex((x) => {
        return x.id === media.id;
      });

      if (index !== -1) {
        this.imagesBlurred[index].url = media.url;
        this.imagesBlurred[index].is_blurred = media.is_blurred;
      }
    },
    buyMedia(media) {
      this.$eventHub.$emit('BuyMediaModalOpen', media);
    },
    openMagnificPopup(mediaId) {
      setTimeout(() => {
        window.openMagnificPopup(mediaId);
      }, 10);
    },
    photoViolationAction(mediaId) {
      window.globals.enableImageMagnificPopup = false;
      this.$eventHub.$emit('PhotoReportModalOpen', mediaId);
      setTimeout(function () {
        window.globals.enableImageMagnificPopup = true;
      }, 100);
    },
  },
  mounted() {
    this.fetchData();

    this.$eventHub.$on('FreshMedia', (media) => {
      this.refreshImage(media);
    });
  }
};
</script>

<style scoped>

</style>
